import { useEffect, useState } from "react";
import userManager from "../features/authorization/authService";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import {
  loadInitialAuthenticationStateAsync,
  selectInitializationStatus,
} from "../features/authentication/authenticationSlice";

const RedirectPage = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const initializationStatus = useAppSelector(selectInitializationStatus);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const isCallback = urlParams.has("code") || urlParams.has("state");

    if (isCallback) {
      userManager
        .signinRedirectCallback()
        .then(() => {
          setLoading(false);
          dispatch(loadInitialAuthenticationStateAsync());
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [navigate, dispatch]);

  useEffect(() => {
    if (loading === false) {
      let redirectUrl = localStorage.getItem("redirectUrl") || "/";
      if (redirectUrl === "/login") {
        redirectUrl = "/";
      }
      navigate(redirectUrl);
    }
  }, [loading, navigate]);

  if (initializationStatus === "not-initialized" || loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <Typography variant="h6">
        You successfully authorized via Google
      </Typography>
    </Box>
  );
};

export default RedirectPage;
